export const homeObjTwo = {
    id: 'discover',
    topLine: '...',
    headLine: 'Get Moving!!!',
    description: 'Whether you’re into bodybuilding, power lifting, strength training or just getting started, these workouts and tips will help you reach your goals.',
    buttonLabel: 'Get started',
    imgStart: true,
    img: require('../../images/svg-2.svg').default,
    alt: 'workout',
    primary: true,
}